import React, { ReactElement } from 'react';

const ColHeader = ({ text, className }: { text: string; className: string }): ReactElement => {
    // font size weight line height color
    return <div className={`small1-medium tracking-0.2' text-left text-light-gray ${className}`}>{text}</div>;
};

export default ColHeader;
